import * as XLSX from 'xlsx';

const generateOverallAccountExcel = (overallData) => {
  const formattedData = overallData.map((item, index) => ({
    'Sr No': index + 1,
    Perticular: `${item?.staff_type || ''} - ${item?.staff_name || ''}`,
    'Credit (₹)': item?.cr_amount || 0,
    'Debit (₹)': item?.dr_amount || 0,
    'Balance (₹)': item?.balance || 0,
  }));

  // Calculate totals
  const totalCredit = overallData.reduce((sum, item) => sum + parseFloat(item?.cr_amount || 0), 0);
  const totalDebit = overallData.reduce((sum, item) => sum + parseFloat(item?.dr_amount || 0), 0);
  const totalBalance = overallData.reduce((sum, item) => sum + parseFloat(item?.balance || 0), 0);

  // Append total row
  formattedData.push({
    'Sr No': '',
    Perticular: 'Total',
    'Credit (₹)': totalCredit,
    'Debit (₹)': totalDebit,
    'Balance (₹)': totalBalance,
  });

  // Create worksheet and add title + headers
  const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

  XLSX.utils.sheet_add_aoa(
    worksheet,
    [
      ['Day Book Report'],
      [],
      ['Sr No', 'Perticular', 'Credit (₹)', 'Debit (₹)', 'Balance (₹)'],
    ],
    { origin: 'A1' },
  );

  // Add data starting from row 4
  XLSX.utils.sheet_add_json(worksheet, formattedData, {
    origin: 'A4',
    skipHeader: true,
  });

  // Merge title row cells
  worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }]; // A1:E1

  // Column widths
  worksheet['!cols'] = [
    { wch: 10 },
    { wch: 30 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Overall Account Report');
  XLSX.writeFile(workbook, 'dayBookReport.xlsx');
};

export default generateOverallAccountExcel;
